import _ from 'lodash';
import dayjs from 'dayjs';
import { Message, MessageBox } from 'element-ui';

/**
 * @description 格式化查询参数
 * @param {Object} data 查询参数
 */
export const formatSearchData = data => {
    const params = _.cloneDeep(data);
    params.dispatchCompletionTimeStart = params.completionTime ? dayjs(params.completionTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.dispatchCompletionTimeEnd = params.completionTime ? dayjs(params.completionTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.dispatchCreateTimeStart = params.createTime ? dayjs(params.createTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.dispatchCreateTimeEnd = params.createTime ? dayjs(params.createTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    delete params.createTime;
    delete params.completionTime;
    return params;
};

/**
 * @description 校验查询参数
 * @param {Object} data 查询参数
 */
export const validateSearchData = data => {
    const dispatchTimeIsExit = (data.dispatchCompletionTimeStart && data.dispatchCompletionTimeEnd) || (data.dispatchCreateTimeStart && data.dispatchCreateTimeEnd);
    if (!data.dispatchNo && !dispatchTimeIsExit) {
        Message.warning('发车单号和发车单创建时间或发车单完成时间不可同时为空');
        return false;
    }
    return validateMaxDate(data, 'dispatchCompletionTimeStart', 'dispatchCompletionTimeEnd', { span: 2, unit: 'month' }) &&
        validateMaxDate(data, 'dispatchCreateTimeStart', 'dispatchCreateTimeEnd', { span: 2, unit: 'month' });
};

export const formatTotalDataList = (data, dictData) => {
    if (!data.length) return [];
    data.forEach((item, index) => {
        item.index = index + 1;
        item.photos = +item.driverCertificate === 1 ? '查看' : '';
        item.confirmStatus = item.confirmStatus === null ? '0' : item.confirmStatus; // null或者0 均为待确认
        item.iflowStatusName = dictData.OTP_APPLY_STATUS[item.iflowStatus] || '';
        item.pushBmsFlagName = dictData.PUSH_BMS_FLAG[item.pushBmsFlag] || ' - ';
        item.isOverConfirm = String(item.isOverConfirm);
    });
    return data;
};

export const setAllPropertyValuesToNull = obj => {
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && key !== 'batchQueryKey') {
            obj[key] = null;
        }
    }
};

/**
 * @description 过滤对象中的空值（空字符串、空对象、空数组、null、undefined）
 * @param {Object} obj 待处理对象
 * @returns {Object} 处理后的真值对象
 */
export const removeFalsyValues = obj => {
    return Object.fromEntries(
        Object.entries(obj).filter(([_, value]) =>
            (!(value === '' || value === null || value === undefined)) &&
            (!(Array.isArray(value) && value.length === 0)) &&
            (!(typeof value === 'object' && Object.keys(value).length === 0))
        )
    );
};

/**
 * @description 按钮操作 二次确认的消息提示
 * @param {String} tipsInfo 提示信息
 * @param {String} api 调用的接口
 * @param {Array/String/Object} params 接口参数
 * @param {String} successTips 操作成功的提示
 * @param {Object} that 接收函数调用者的 this
 */
export const messageTips = (tipsInfo = '此操作将永久修改该数据, 是否继续？', api, params, successTips = '操作成功', that) => {
    MessageBox.confirm(tipsInfo, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = '执行中...';
                api(params)
                    .then(res => {
                        if (res && +res.code === 0) {
                            Message.success(successTips);
                            done();
                        }
                    })
                    .catch((errMsg) => {
                        Message.error(errMsg);
                    })
                    .finally(() => {
                        instance.confirmButtonLoading = false;
                        done();
                        that.getList();
                    });
            } else {
                done();
            }
        }
    }).catch(() => { }); // 添加错误捕获
};

/**
 * @description 校验查询时间跨度不能超过指定日期
 * @param {Object} searchData 查询参数
 * @param {String} sDateField 查询起始时间字段名
 * @param {String} eDateField 查询结束时间字段名
 * @param {{ span: number, unit: dayjs.ManipulateType, noMessage: boolean, addOneDay: boolean }} 配置时间范围限制
 */
const validateMaxDate = (searchData, sDateField, eDateField, options, searchType = '时间') => {
    if (searchData[sDateField] && searchData[eDateField]) {
        if (!options) {
            const sDateTimeStamp = new Date(searchData[sDateField]).getTime();
            const eDateTimeStamp = new Date(searchData[eDateField]).getTime();
            const maxDay = 1000 * 60 * 60 * 24 * 63; // 按31天来算，组件问题，得加多一天
            if (eDateTimeStamp - sDateTimeStamp > maxDay) {
                Message.warning(`按${searchType}查询或导出时，查询或导出时间跨度不可超过两个月`);
                return false;
            }
        } else {
            const { span = 2, unit = 'month', noMessage = false, addOneDay = true } = options || {};
            const sDate = dayjs(searchData[sDateField]);
            const eDate = dayjs(searchData[eDateField]);
            let addedTime = sDate.startOf('day')
                .add(span, unit);
            if (addOneDay) {
                addedTime = addedTime.add(2, 'day'); // OTP时间选择组件问题，多加一天;大小月 无法选择问题，再多加一天
            }
            const eTime = eDate.endOf('day');
            const isValid = addedTime.isAfter(eTime);
            if (!isValid && !noMessage) {
                const unitNames = {
                    day: '天',
                    month: '个月',
                    week: '周',
                    year: '年'
                };
                Message.warning(`按${searchType}查询或导出时，查询或导出时间跨度不可超过${span}${unitNames[unit]}`);
            }
            return isValid;
        }
    }
    return true;
};
